import React from 'react';
import { Table } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import {
	QUES_CODE_PREFIX,
	formatBrsrNumericCellValue,
	getFormattedTextEmbeddedinLITag,
	renderQuestionAnswer
} from '../../../../core/utilities/BRSRUtils';
import './../Reporting.scss';

const BRSRPrinciple9 = ({
	t,
	page10,
	yearFilter
}) => {


	const renderP9Q1 = () => {
		const currentYearAnswer = {};
		if (page10?.['currentYear']) {
			page10['currentYear'][QUES_CODE_PREFIX + 'P9-1']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return renderQuestionAnswer('1. Describe the mechanisms in place to receive and respond to consumer complaints and feedback.', currentYearAnswer[QUES_CODE_PREFIX + 'P9-1a'] ?? '');
	};

	const renderP9Q2 = () => {
		const currentYearAnswer = {};
		if (page10?.['currentYear']) {
			page10['currentYear'][QUES_CODE_PREFIX + 'P9-2']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>2. Turnover of products and/ services as a percentage of turnover from all products/service that carry information about</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th></th>
								<th>As a percentage to total turnover</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Environmental and social parameters relevant to the product</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P9-2a'] ?? ''}</td>
							</tr>
							<tr>
								<td>Safe and responsible usage</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P9-2b'] ?? ''}</td>
							</tr>
							<tr>
								<td>Recycling and/or safe disposal</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P9-2c'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP9Q3 = () => {
		const currentYearAnswer = {};
		const previousYearAnswer = {};
		if (page10?.['currentYear']) {
			page10['currentYear'][QUES_CODE_PREFIX + 'P9-3']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		if (page10?.['previousYear']) {
			page10['previousYear'][QUES_CODE_PREFIX + 'P9-3']?.keyValues?.forEach(val => {
				previousYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>3. Number of consumer complaints in respect of the following:</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th rowSpan={2}></th>
								<th colSpan={2} className="text-center FY_class white-nowrap">FY ({yearFilter})</th>
								<th rowSpan={2}>Remarks</th>
								<th colSpan={2} className="text-center white-nowrap">FY ({yearFilter - 1})</th>
								<th rowSpan={2}>Remarks</th>
							</tr>
							<tr>
								<th className='FY_class_sub'>Received during the year</th>
								<th className='FY_class_sub'>Pending resolution at end of year</th>
								<th>Received during the year</th>
								<th>Pending resolution at end of year</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Data privacy</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P9-3aa'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P9-3ab'] ?? ''}</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P9-3ac'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P9-3aa'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P9-3ab'] ?? ''}</td>
								<td>{previousYearAnswer[QUES_CODE_PREFIX + 'P9-3ac'] ?? ''}</td>
							</tr>
							<tr>
								<td>Advertising</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P9-3ba'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P9-3bb'] ?? ''}</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P9-3bc'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P9-3ba'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P9-3bb'] ?? ''}</td>
								<td>{previousYearAnswer[QUES_CODE_PREFIX + 'P9-3bc'] ?? ''}</td>
							</tr>
							<tr>
								<td>Cyber-security</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P9-3ca'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P9-3cb'] ?? ''}</td>
								<td >{currentYearAnswer[QUES_CODE_PREFIX + 'P9-3cc'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P9-3ca'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P9-3cb'] ?? ''}</td>
								<td >{previousYearAnswer[QUES_CODE_PREFIX + 'P9-3cc'] ?? ''}</td>
							</tr>
							<tr>
								<td>Delivery of essential services</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P9-3da'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P9-3db'] ?? ''}</td>
								<td >{currentYearAnswer[QUES_CODE_PREFIX + 'P9-3dc'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P9-3da'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P9-3db'] ?? ''}</td>
								<td >{previousYearAnswer[QUES_CODE_PREFIX + 'P9-3dc'] ?? ''}</td>
							</tr>
							<tr>
								<td>Restrictive Trade Practices</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P9-3ea'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P9-3eb'] ?? ''}</td>
								<td >{currentYearAnswer[QUES_CODE_PREFIX + 'P9-3ec'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P9-3ea'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P9-3eb'] ?? ''}</td>
								<td>{previousYearAnswer[QUES_CODE_PREFIX + 'P9-3ec'] ?? ''}</td>
							</tr>
							<tr>
								<td>Unfair Trade Practices</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P9-3fa'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P9-3fb'] ?? ''}</td>
								<td >{currentYearAnswer[QUES_CODE_PREFIX + 'P9-3fc'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P9-3fa'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P9-3fb'] ?? ''}</td>
								<td >{previousYearAnswer[QUES_CODE_PREFIX + 'P9-3fc'] ?? ''}</td>
							</tr>
							<tr>
								<td>Other</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P9-3ga'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P9-3gb'] ?? ''}</td>
								<td >{currentYearAnswer[QUES_CODE_PREFIX + 'P9-3gc'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P9-3ga'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P9-3gb'] ?? ''}</td>
								<td >{previousYearAnswer[QUES_CODE_PREFIX + 'P9-3gc'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP9Q4 = () => {
		const currentYearAnswer = {};
		if (page10?.['currentYear']) {
			page10['currentYear'][QUES_CODE_PREFIX + 'P9-4']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>4. Details of instances of product recalls on account of safety issues:</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th></th>
								<th>Number</th>
								<th>Reasons for recall</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Voluntary recalls</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P9-4aa'] ?? ''}</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P9-4ab'] ?? ''}</td>
							</tr>
							<tr>
								<td>Forced recalls</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P9-4ba'] ?? ''}</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P9-4bb'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP9Q5 = () => {
		const currentYearAnswer = {};
		if (page10?.['currentYear']) {
			page10['currentYear'][QUES_CODE_PREFIX + 'P9-5']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return renderQuestionAnswer('5. Does the entity have a framework/ policy on cyber security and risks related to data privacy? (Yes/No). If available, provide a web-link of the policy.', currentYearAnswer[QUES_CODE_PREFIX + 'P9-5a'] ?? '');
	};

	const renderP9Q6 = () => {
		const currentYearAnswer = {};
		if (page10?.['currentYear']) {
			page10['currentYear'][QUES_CODE_PREFIX + 'P9-6']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return renderQuestionAnswer('6. Provide details of any corrective actions taken or underway on issues relating to advertising, and delivery of essential services; cyber security and data privacy of customers; re-occurrence of instances of product recalls; penalty / action taken by regulatory authorities on safety of products / services.', currentYearAnswer[QUES_CODE_PREFIX + 'P9-6a'] ?? '');
	};

	const renderP9Q7 = () => {
		const currentYearAnswer = {};
		if (page10?.['currentYear']) {
			page10['currentYear'][QUES_CODE_PREFIX + 'P9-7']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>7. Provide the following information relating to data breaches</b>
				{renderQuestionAnswer('a. Number of instances of data breaches', currentYearAnswer[QUES_CODE_PREFIX + 'P9-7a'] ?? '')}
				{renderQuestionAnswer('b. Percentage of data breaches involving personally identifiable information of customers', currentYearAnswer[QUES_CODE_PREFIX + 'P9-7b'] ?? '')}
				{renderQuestionAnswer('c. Impact, if any, of the data breaches', currentYearAnswer[QUES_CODE_PREFIX + 'P9-7c'] ?? '')}
			</div>
		);
	};

	const renderP9LIQ1 = () => {
		const currentYearAnswer = {};
		if (page10?.['currentYear']) {
			page10['currentYear'][QUES_CODE_PREFIX + 'P9-LI1']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return renderQuestionAnswer('1. Channels / platforms where information on products and services of the entity can be accessed (provide web link, if available).', currentYearAnswer[QUES_CODE_PREFIX + 'P9-LI1a'] ?? '');
	};

	const renderP9LIQ2 = () => {
		const currentYearAnswer = {};
		if (page10?.['currentYear']) {
			page10['currentYear'][QUES_CODE_PREFIX + 'P9-LI2']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return renderQuestionAnswer('2. Steps taken to inform and educate consumers about safe and responsible usage of products and/or services.', currentYearAnswer[QUES_CODE_PREFIX + 'P9-LI2a'] ?? '');
	};

	const renderP9LIQ3 = () => {
		const currentYearAnswer = {};
		if (page10?.['currentYear']) {
			page10['currentYear'][QUES_CODE_PREFIX + 'P9-LI3']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return renderQuestionAnswer('3. Mechanisms in place to inform consumers of any risk of disruption/discontinuation of essential services.', currentYearAnswer[QUES_CODE_PREFIX + 'P9-LI3a'] ?? '');
	};

	const renderP9LIQ4 = () => {
		const currentYearAnswer = {};
		if (page10?.['currentYear']) {
			page10['currentYear'][QUES_CODE_PREFIX + 'P9-LI4']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return renderQuestionAnswer('4. Does the entity display product information on the product over and above what is mandated as per local laws? (Yes/No/Not Applicable) If yes, provide details in brief. Did your entity carry out any survey with regard to consumer satisfaction relating to the major products / services of the entity, significant locations of operation of the entity or the entity as a whole? (Yes/No)', currentYearAnswer[QUES_CODE_PREFIX + 'P9-LI4a'] ?? '');
	};

	return (
		<section id="PRINCIPLE_9" className="Main_Section PRINCIPLE_9">
			<div className="ETA_card_Section 1">
				<div className="ETA_card_Section_head mb-3">
					<h5>PRINCIPLE 9 Businesses should engage with and provide value to their consumers in a responsible manner</h5>
				</div>
				<div className="ETA_card_Section_sub">
					<section className="mb-4">
						<div className="ETA_card_Section_sub_head mb-3">
							<b>Essential Indicators</b>
						</div>
						<div className="ETA_card_Section_sub_body">
							<div className='brsr-list'>
								{renderP9Q1()}
								{renderP9Q2()}
								{renderP9Q3()}
								{renderP9Q4()}
								{renderP9Q5()}
								{renderP9Q6()}
								{renderP9Q7()}
							</div>
						</div>
					</section>
				</div>
				<div className="ETA_card_Section_sub mt-2 mb-2">
					<section className="mb-4">
						<div className="ETA_card_Section_sub_head mb-3">
							<b>Leadership Indicators</b>
						</div>
						<div className="ETA_card_Section_sub_body">
							<div className='brsr-list'>
								{renderP9LIQ1()}
								{renderP9LIQ2()}
								{renderP9LIQ3()}
								{renderP9LIQ4()}
							</div>
						</div>
					</section>
				</div>
			</div>
		</section>
	);
};

export default withTranslation()(BRSRPrinciple9);
